import { useCallback } from "react";
import { GtmEvent } from "~/lib/gtm/getGtmEventData";
import { sendGtmEvent } from "~/lib/gtm/gE";
import { sendWebEvent } from "~/lib/webevents/WebEventsClient";
import { useUnauthorizedEventService } from "~/services/api/services/event";
import { isEmpty } from "~/utils/isEmpty";

export const useTrackEvent = () => {
    const sendBigQueryEvent = useUnauthorizedEventService();

    return useCallback(
        (event: GtmEvent | undefined, href = "", text = "") => {
            if (!event || isEmpty(event)) return;

            if (!event.value.href && href) event.value.href = href;
            if (text) event.value.meta_data.click_text = text;

            if (event.value.href) {
                const isExternal = event.value.href?.startsWith("http");
                const url = isExternal ? new URL(event.value.href!) : undefined;
                const isThirdParty =
                    isExternal &&
                    url &&
                    !url.hostname.includes("innerbalance.com");
                event.value.href =
                    isThirdParty || !url ? event.value.href : url.pathname;
            }

            sendGtmEvent(event);
            sendWebEvent(sendBigQueryEvent, {
                event_type: event.event,
                ...event.value,
            });
        },
        [sendBigQueryEvent]
    );
};
